import type { MessageKey } from './en';

const cs: Record<MessageKey, string> = {
  'common.quoted': '„{value}"',
  'common.uciIdMissing': 'bez UCI ID',
  'common.unknownPlaceholder': '?',
  'common.sexWoman': 'ženy',
  'common.sexMan': 'muži',
  'common.optional': 'volitelné',
  'common.edit': 'Upravit',
  'common.delete': 'Smazat',
  'common.done': 'Hotovo',
  'common.cancel': 'Zrušit',
  'common.close': 'Zavřít',
  'common.reset': 'Obnovit',
  'common.language': 'Jazyk',
  'common.theme': 'Vzhled',
  'common.theme.system': 'Systém',
  'common.theme.light': 'Světlý',
  'common.theme.dark': 'Tmavý',
  'common.back': 'Zpět',

  'starterType.single': 'Jednotlivec',
  'starterType.pair': 'Dvojice',
  'starterType.team4': 'Čtyřčlenné družstvo',
  'starterType.team6': 'Šestičlenné družstvo',

  'ageTier.eliteJunior': 'Elita / Junioři',
  'ageTier.youth': 'Žáci (Schüler)',

  'app.title': 'Kür',
  'app.subtitle': 'Přihláška krasojízdy',
  'app.nav': 'Hlavní navigace',
  'app.menu': 'Nabídka',
  'app.drawerMenu': 'Navigační nabídka',
  'app.open': 'Otevřít',
  'app.save': 'Uložit',
  'app.importSelection': 'Importovat…',
  'app.exportSelection': 'Exportovat…',
  'app.weboImport': 'Import z WeBo…',
  'app.settings': 'Nastavení',
  'app.about': 'O aplikaci',
  'app.mainMissing': 'Chybí hlavní obsah.',
  'app.opened': 'Soubor {file} otevřen.',
  'app.openFailed': 'Tento soubor nelze načíst jako pracovní prostor.',
  'nav.home': 'Domů',
  'nav.registrationData': 'Přihláška',
  'nav.competitions': 'Závody',
  'nav.clubs': 'Kluby',
  'nav.athletes': 'Sportovci',
  'nav.starter': 'Startující',
  'nav.programme': 'Sestava',
  'nav.entries': 'Přihlášky',
  'nav.impressum': 'Právní upozornění',
  'nav.datenschutz': 'Zásady ochrany osobních údajů',

  'home.welcome.title': 'Vítejte v Kür',
  'home.welcome.text':
    'Kür vám pomůže přihlásit sportovce a jejich soutěžní sestavy pro krasojízdu — od sestavení sestavy až po hotový export XML.',
  'home.howto.title': 'Jak na to',
  'home.howto.step1': 'Vytvořit [klub:clubs] a [sportovce:athletes]',
  'home.howto.step2': 'Sestavit sestavu z [katalogu prvků:programme]',
  'home.howto.step3': 'Přihlásit se na [závod:competitions] a [exportovat:entries] XML',
  'home.start': 'Začít',
  'home.importExport.title': 'Import a export',
  'home.importExport.text':
    'V horní liště (nebo v nabídce „⋮“ na mobilu) můžete celý pracovní prostor [otevřít:open] nebo [uložit:save] jako soubor, případně [importovat:import] a [exportovat:export] jen jeho část – například sportovce nebo jednu sestavu. Stejná tlačítka najdete i dole na stránce [Přihlášky:entries].',
  'home.privacy.title': 'Vaše data zůstávají ve vašem zařízení',
  'home.privacy.text':
    'Kür funguje zcela offline — vše, co zadáte, se ukládá pouze do lokálního úložiště vašeho prohlížeče na tomto zařízení. Nikdo jiný, včetně nás, k tomu nemá přístup. To také znamená, že jste sami zodpovědní za uložení pracovního prostoru do souboru a jeho archivaci — nikde jinde se nic nezálohuje.',
  'home.install.title': 'Instalovat Kür',
  'home.install.already': 'Používáte nainstalovanou aplikaci — funguje offline a otevírá se ve vlastním okně.',
  'home.install.button': 'Instalovat',
  'home.install.prompt':
    'Nainstalujte si Kür jako aplikaci pro rychlý přístup a plné offline použití, bez lišty prohlížeče.',
  'home.install.ios':
    'Klepněte na ikonu Sdílet a poté na „Přidat na plochu" — Kür se poté otevře jako jakákoli jiná aplikace a funguje zcela offline.',
  'home.install.macSafari':
    'Otevřete nabídku Sdílet (nebo Soubor → Přidat do Docku) a zvolte „Přidat do Docku" — Kür se poté otevře jako jakákoli jiná aplikace a funguje zcela offline.',
  'home.install.android':
    'Otevřete nabídku prohlížeče a vyhledejte „Přidat na plochu" nebo „Instalovat aplikaci" — Kür se poté otevře jako jakákoli jiná aplikace a funguje zcela offline.',
  'home.install.desktop':
    'Hledejte ikonu instalace v adresním řádku, nebo možnost „Instalovat Kür…" v nabídce prohlížeče — aplikace se poté otevře ve vlastním okně a funguje zcela offline.',
  'home.install.unsupported':
    'Váš prohlížeč nenabízí instalaci Kür jako aplikace, ale i tak funguje zcela offline, jakmile ji zde jednou otevřete.',

  'about.title': 'O aplikaci Kür',
  'about.story.title': 'Proč Kür vzniklo',
  'about.story.p1': 'Moje přítelkyně vyrostla v krasojízdě a miluje tento sport celým srdcem. Před časem se rozhodla se svou parťačkou znovu zkusit závodit. Obě spolu opakovaně sedávaly celé hodiny jen kvůli sestavení sestavy — a dlouho jsem nechápal, proč to trvá tak dlouho.',
  'about.story.p2': 'Pak jsem se podíval na nástroje, které se k tomu dodnes používají — na svou dobu solidně udělané, ale dnes už zastaralé, a každá změna trvala déle, než musela. Když s tím měly co dělat i dvě zkušené sportovkyně, nováčkům to asi jednodušší nebude. Jako bývalý vedoucí vývoje softwaru jsem si řekl: dnes to jde udělat jednodušeji.',
  'about.story.p3': 'Tak jsem s pomocí Claude postavil mobile-first webovou aplikaci, ve které lze sestavu rychle poskládat, vyzkoušet a zase zahodit — s vestavěnými kontrolami a vizualizací návaznosti prvků, aby byla stavba sestavy srozumitelná na první pohled. Tak vzniklo Kür.',
  'about.howto.title': 'Sestavení přihlášky',
  'about.howto.lede': 'Obrazovky v navigaci jdou v tomto pořadí, lze je ale otevírat kdykoli v libovolném pořadí — nic nemusí být hotové, než se pokračuje dál.',
  'about.howto.registrationData': 'Údaje přihlášky — váš klub a kontaktní osoba odpovědná za přihlášku.',
  'about.howto.competitions': 'Závody — každý závod, na který se přihlašujete.',
  'about.howto.clubs': 'Kluby — každý zúčastněný klub, vytvořený jednou a poté jen vybíraný, kde je potřeba.',
  'about.howto.athletes': 'Sportovci — každý závodník, přiřazený ke klubu a později ke startujícím.',
  'about.howto.starter': 'Startující — kdo startuje společně: jednotlivec, dvojice, čtyřčlenné nebo šestičlenné družstvo.',
  'about.howto.programme': 'Sestava — seřazená posloupnost prvků, kterou startující předvádí, sestavená z katalogu cviků.',
  'about.howto.entries': 'Přihlášky — spojují startujícího, sestavu a závod; každá přihláška vytváří vlastní export.',
  'about.howto.footnote': 'Otevřete přihlášku na obrazovce Přihlášky, abyste ji zkontrolovali podle obou schémat a stáhli XML.',
  'about.sbom.title': 'Open-source součásti',
  'about.sbom.lede': 'Kür je postaven na open-source knihovnách níže, automaticky generovaných ze souboru package.json projektu — tento seznam je vždy aktuální.',
  'about.sbom.runtime': 'Doručeno do prohlížeče',
  'about.sbom.build': 'Pouze nástroje pro sestavení',
  'about.support.title': 'Podpořte Kür',
  'about.support.text': 'Na Kür nevydělávám — chci jen, aby se komunita krasojízdy zbavila starých nástrojů. Hosting a zveřejnění v app storech mě přesto stojí asi 200 € ročně. Pokud vám Kür pomáhá, budu rád za kávu tu a tam. Některé verze aplikace kvůli tomu zobrazují malý, nenápadný reklamní banner, který lze odstranit malým nákupem v aplikaci — obojí zůstává čistě volitelné a nijak neovlivňuje fungování Kür.',

  'legal.impressum.placeholder':
    'Údaje podle § 5 německého zákona o digitálních službách (Digitale-Dienste-Gesetz, DDG)\n\nBenedikt-Alexander Mokroß\nc/o Impressumservice Dein-Impressum\nStettiner Str. 41\n35410 Hungen\nNěmecko\n\nKontakt\nE-mail: info@kuer.eu\n\nKür je soukromý, nekomerční projekt.\n\nOdpovědnost za obsah\nJako poskytovatel služby odpovídám za vlastní obsah na těchto stránkách podle obecných zákonů (§ 7 odst. 1 DDG). Podle §§ 8 až 10 DDG však nejsem povinen dohlížet na přenášené nebo uložené informace třetích stran ani aktivně vyhledávat okolnosti nasvědčující protiprávní činnosti. Povinnosti odstranit nebo zablokovat používání informací podle obecných zákonů tím zůstávají nedotčeny; odpovědnost je však možná až od okamžiku, kdy se o konkrétním porušení práva dozvím. Jakmile se o takovém porušení dozvím, příslušný obsah neprodleně odstraním.\n\nOdpovědnost za odkazy\nTato aplikace může odkazovat na externí webové stránky třetích stran, na jejichž obsah nemám žádný vliv. Za tento cizí obsah proto nemohu převzít žádnou záruku; odpovědnost nese vždy příslušný provozovatel odkazované stránky. Odkazované stránky byly v okamžiku vytvoření odkazu zkontrolovány ohledně zjevných porušení práva. Trvalá kontrola obsahu odkazovaných stránek bez konkrétních podnětů k porušení práva není přiměřeně vyžadovatelná. Jakmile se o porušení práva dozvím, takové odkazy neprodleně odstraním.\n\nAutorská práva\nObsah, který jsem na těchto stránkách vytvořil, podléhá německému autorskému právu. Příspěvky třetích stran jsou jako takové označeny. Rozmnožování, zpracování, šíření nebo jakékoli jiné využití nad rámec autorského práva vyžaduje můj písemný souhlas.',
  'legal.datenschutz.placeholder':
    'Zásady ochrany osobních údajů podle GDPR\n\nSprávce\nBenedikt-Alexander Mokroß\nc/o Impressumservice Dein-Impressum\nStettiner Str. 41\n35410 Hungen\nNěmecko\nE-mail: info@kuer.eu\n\nPřehled\nKür prakticky nezpracovává žádné osobní údaje na serveru. Váš pracovní prostor — kluby, sportovci, startující, sestavy, přihlášky — je uložen výhradně na vašem zařízení ve vašem prohlížeči a nikdy se automaticky nepřenáší. Neexistuje žádný uživatelský účet, žádné přihlašování ani ukládání dat vašeho pracovního prostoru na serveru.\n\nMístní úložiště v prohlížeči\nAplikace ve místním úložišti vašeho zařízení ukládá váš aktuální pracovní prostor, vaši volbu jazyka a motivu a vaši volbu ohledně cookies. Tato data neopustí vaše zařízení, pokud je sami neexportujete jako soubor nebo nevygenerujete XML přihlášku ke stažení. Právním základem je čl. 6 odst. 1 písm. b) GDPR pro váš pracovní prostor (splnění účelu, pro který aplikaci používáte) a čl. 6 odst. 1 písm. f) GDPR pro pohodlnostní nastavení, jako je jazyk a motiv (oprávněný zájem na funkční aplikaci). Tato data zůstávají uložena, dokud je nesmažete nebo nevymažete úložiště prohlížeče — neexistuje žádná automatická lhůta pro výmaz ani uchovávání na serveru, protože žádné ukládání na serveru neprobíhá.\n\nNastavení cookies\nPři první návštěvě se vás aplikace zeptá, zda smí do budoucna aktivovat další, zatím neimplementované funkce — statistiky používání a hlášení pádů a chyb. Vaše volba se ukládá lokálně a bez časového omezení (viz výše) a lze ji kdykoli změnit přes „Nastavení cookies“ v menu. Dokud tyto funkce neexistují, vaše volba nemá žádný účinek: nesbírají se ani nepřenášejí žádné odpovídající údaje.\n\nPísma\nPoužitá písma Archivo a IBM Plex Mono jsou součástí aplikace a jsou načítána z našeho vlastního serveru. Nedochází k žádnému spojení se službou Google Fonts ani jiným poskytovatelem písem.\n\nHosting a serverové log soubory\nTento web je provozován u poskytovatele STRATO GmbH. Při přístupu na web hostitel automaticky zpracovává technické přístupové údaje — mimo jiné IP adresu, datum a čas přístupu, vyžádaný soubor, objem přenesených dat, prohlížeč/operační systém a odkazující URL —, jak je technicky nezbytné pro provoz jakéhokoli webového serveru. Tyto log soubory slouží technickému zajištění, stabilitě a bezpečnosti webu a nejsou kombinovány s jinými zdroji dat. Právním základem je čl. 6 odst. 1 písm. f) GDPR (oprávněný zájem na funkčním a bezpečném provozu). V rozsahu vyžadovaném zákonem existuje se společností STRATO smlouva o zpracování údajů podle čl. 28 GDPR.\n\nKontaktování e-mailem\nPokud mě kontaktujete e-mailem, zpracovávám údaje, které mi sdělíte — zejména vaši e-mailovou adresu a obsah zprávy — výhradně za účelem vyřízení vašeho dotazu (čl. 6 odst. 1 písm. b) nebo f) GDPR). Tyto údaje smažu, jakmile již nejsou potřebné, pokud tomu nebrání zákonné povinnosti uchovávání.\n\nPředávání třetím stranám\nVaše údaje nejsou předávány žádné třetí straně, s výjimkou technicky nezbytného zpracování poskytovatelem hostingu popsaného v části „Hosting a serverové log soubory“.\n\nŽádné automatizované rozhodování\nNedochází k žádnému automatizovanému rozhodování ani profilování ve smyslu čl. 22 GDPR.\n\nVaše práva\nMáte právo na přístup (čl. 15 GDPR), opravu (čl. 16 GDPR), výmaz (čl. 17 GDPR), omezení zpracování (čl. 18 GDPR), přenositelnost údajů (čl. 20 GDPR) a vznesení námitky proti zpracování (čl. 21 GDPR). Udělený souhlas můžete kdykoli s účinkem do budoucna odvolat (čl. 7 odst. 3 GDPR), například prostřednictvím nastavení cookies. Máte také právo podat stížnost u dozorového úřadu (čl. 77 GDPR) — obvykle příslušným úřadem je Hesenský pověřenec pro ochranu osobních údajů a svobodu informací (HBDI), neboť mé sídlo se nachází ve spolkové zemi Hesensko.\n\nZměny těchto zásad\nTyto zásady ochrany osobních údajů budou upraveny, jakmile se změní skutečné zpracování údajů — například při zavedení statistik používání, hlášení pádů nebo ukládání pracovních prostorů na serveru. Rozhodná je vždy verze aktuálně zobrazená v aplikaci.',

  'consent.title': 'Nastavení cookies',
  'consent.intro': 'Kür ukládá váš pracovní prostor pouze na tomto zařízení. Pokud později přidáme funkce, které odesílají data jinam, zůstanou vypnuté, dokud je zde nepovolíte — svou volbu můžete kdykoli změnit na této obrazovce.',
  'consent.category.necessary.label': 'Nezbytné',
  'consent.category.necessary.desc': 'Udržují aplikaci funkční: ukládání pracovního prostoru na tomto zařízení a zapamatování jazyka a motivu. Vždy zapnuté.',
  'consent.category.statistics.label': 'Statistiky používání',
  'consent.category.statistics.desc': 'Anonymní data o používání, aby bylo vidět, které funkce se využívají. Zatím není implementováno — tento přepínač zatím nemá žádný účinek.',
  'consent.category.crashReports.label': 'Hlášení pádů a chyb',
  'consent.category.crashReports.desc': 'Odesílá podrobnosti o pádech, aby je bylo možné opravit. Zatím není implementováno — tento přepínač zatím nemá žádný účinek.',
  'consent.rejectAll': 'Pouze nezbytné',
  'consent.saveSelection': 'Uložit výběr',
  'consent.acceptAll': 'Přijmout vše',
  'consent.privacyLink': 'Přečíst úplné zásady ochrany osobních údajů',

  'registrationData.title': 'Údaje přihlášky',
  'registrationData.lede': 'Tyto údaje jsou v hlavičce obou XML souborů. Zadávají se jen jednou, platí pro všechny přihlášky.',
  'registrationData.club.title': 'Přihlašující klub',
  'meldedaten.field.club': 'Klub',
  'meldedaten.field.regionalFederation': 'Zemský svaz',
  'meldedaten.field.federation': 'Svaz / oblast',
  'registrationData.contact.title': 'Odpovědná osoba / referent klubu',

  'field.firstName': 'Jméno',
  'field.lastName': 'Příjmení',
  'field.uciId': 'UCI ID',
  'field.email': 'E-mail',
  'field.street': 'Ulice',
  'field.phone': 'Telefon',
  'field.postalCode': 'PSČ',
  'field.city': 'Město',
  'field.countryCode': 'Kód země',
  'field.fax': 'Fax',
  'field.maxLength': 'max. {n}',

  'competitions.title': 'Závody',
  'competitions.lede': 'Přidej každý závod, na který přihlašuješ. Na obrazovce Přihlášky pak ke každé přihlášce vybereš závod, startujícího a sestavu.',
  'competitions.field.name': 'Závod',
  'competitions.field.date': 'Datum',
  'competitions.field.austragungsort': 'Místo konání',
  'competitions.field.organiser': 'Pořadatel',
  'competitions.add': 'Přidat závod',
  'competitions.empty.title': 'Zatím žádné závody',
  'competitions.empty.text': 'Přidej závod a poté k němu na obrazovce Přihlášky vytvoř přihlášky.',
  'competitions.unnamed': 'Závod bez názvu',
  'competitions.form.title': 'Upravit závod',
  'competitions.deleteConfirm': 'K tomuto závodu je zapsáno {used} přihlášek, které se smažou také. Přesto smazat?',
  'competitions.deleted': 'Závod smazán.',

  'clubs.title': 'Kluby',
  'clubs.lede': 'Každý klub se vytvoří jednou a poté se u každého sportovce jen vybere.',
  'clubs.empty.title': 'Zatím žádné kluby',
  'clubs.empty.text': 'Zúčastněné kluby vytvoř jednou — poté se klub u každé osoby jen vybírá, nepíše se znovu.',
  'clubs.add': 'Vytvořit klub',
  'clubs.unnamed': 'Bez názvu',
  'clubs.row.number': 'č. {number}',
  'clubs.row.contact': 'Kontaktní osoba: {name}',
  'clubs.deleteConfirm': 'Tento klub má už zapsáno {used} sportovce(ů). Zůstane tam jako text. Přesto smazat?',
  'clubs.deleted': 'Klub smazán.',
  'clubs.form.title': 'Upravit klub',
  'clubs.field.name': 'Klub',
  'clubs.field.nation': 'Národnost',
  'clubs.field.federation': 'Svaz',
  'clubs.field.number': 'Číslo',
  'clubs.contact.title': 'Kontaktní osoba',

  'athletes.title': 'Sportovci',
  'athletes.lede': 'Každá osoba se vytvoří jednou a poté může být přiřazena k libovolnému počtu startujících.',
  'athletes.empty.title': 'Zatím žádní sportovci',
  'athletes.empty.text': 'Nejprve vytvoř sportovce. Poté z nich sestavíš startující.',
  'athletes.add': 'Přidat sportovce',
  'athletes.unnamed': 'Sportovec bez jména',
  'athletes.deleteConfirm': 'Tato osoba je přiřazena k {count} startujícím. Přesto smazat?',
  'athletes.deleted': 'Osoba smazána.',
  'athletes.form.title': 'Upravit sportovce',
  'athletes.field.birthDate': 'Datum narození',
  'athletes.field.nation': 'Národnost',
  'athletes.field.sex': 'Pohlaví',
  'athletes.field.club': 'Klub',
  'athletes.club.none': '– žádný klub –',
  'athletes.club.emptyHint': 'zatím nebyl vytvořen žádný klub',

  'starter.title': 'Startující',
  'starter.lede': 'Startující je jednotlivec, dvojice nebo čtyř- či šestičlenné družstvo — s disciplínou a přiřazenými sportovci. Sestavy a přihlášky se sestavují samostatně.',
  'starter.empty.title': 'Zatím žádní startující',
  'starter.empty.text': 'Startující spojuje disciplínu s osobami, které spolu závodí.',
  'starter.add': 'Vytvořit startujícího',
  'starter.unnamed': 'Nový startující',
  'starter.riderLimitToast': '{label} startuje s {max} osobami.',
  'starter.deleteConfirm': 'Tento startující je použit v {used} přihláškách, které se tím smažou také. Přesto smazat?',
  'starter.deleted': 'Startující smazán.',
  'starter.form.title': 'Upravit startujícího',
  'starter.field.type': 'Typ',
  'starter.field.discipline': 'Disciplína',
  'starter.field.startername': 'Jméno startujícího',
  'starter.field.startername.hint': 'prázdné = z příjmení',
  'starter.personen.title': 'Osoby',
  'starter.personen.needSportler': 'Nejprve vytvoř osoby v sekci <b>Sportovci</b>.',
  'starter.personen.pick': 'Osoba',
  'starter.personen.pickPlaceholder': '– vyber osobu –',
  'starter.riderTag': '{have} z {need} osob',
  'starter.sgTag': 'Společný start (SG)',
  'starter.sexMismatchTag': 'Pohlaví neodpovídá disciplíně',
  'starter.derived.club': 'Klub: <b>{club}</b>',
  'starter.derived.sg': ' · <b>Společný start (SG)</b>',
  'starter.derived.sex': ' · Hodnoceno jako: <b>{sex}</b>',
  'starter.derived.note': 'Vychází z klubů a pohlaví přiřazených osob.',
  'starter.derived.note.alias': 'Zkráceno pro export z plného názvu klubu „{full}".',
  'starter.derived.note.autoTruncated': 'Pro export automaticky zkráceno na {max} znaků, stejně jako to dělá WeBo2008. Pro hezčí zkratku zadejte níže vlastní krátký název.',
  'starter.aliasTag': 'Zkrácený název klubu',
  'starter.clubAlias.autoTruncated': 'Spojený název klubu „{full}" má {len} znaků — export povoluje jen {max}, proto byl automaticky zkrácen. Pro hezčí zkratku zadejte níže kratší název.',
  'starter.clubAlias.aliasStillOverLimit': 'Krátký název klubu má stále {len} znaků — export povoluje jen {max}. Zkraťte ho ještě více.',
  'starter.field.clubAlias': 'Krátký název klubu',
  'starter.field.clubAlias.hint': 'použije se v exportu místo plného názvu výše',
  'starter.sexMismatch.one': 'Tato disciplína je ženská kategorie, ale {names} není evidován(a) jako žena.',
  'starter.sexMismatch.many': 'Tato disciplína je ženská kategorie, ale {names} nejsou evidováni jako ženy.',
  'starter.personalBest.title': 'Osobní nejlepší výkon',
  'starter.field.points': 'Body',
  'starter.field.date': 'Datum',
  'starter.field.venue': 'Místo',
  'starter.field.scoringReportEmail': 'E-mail pro hodnoticí zprávu',

  'programme.title': 'Sestavy',
  'programme.titleWithName': 'Sestava: {name}',
  'programme.editName': 'Přejmenovat sestavu',
  'programme.select': 'Vyber sestavu',
  'programme.list.meta': '{count}/{limit} · {points} b.',
  'programme.empty.title': 'Zatím žádné sestavy',
  'programme.empty.text': 'Sestava patří k typu startujícího (jednotlivec, dvojice, čtyř- nebo šestičlenné družstvo) a věkové kategorii, ne ke konkrétnímu startujícímu — přiřazení ke startujícímu a závodu se dělá na obrazovce Přihlášky.',
  'programme.new.button': 'Nová sestava',
  'programme.new.title': 'Nová sestava',
  'programme.new.type': 'Typ',
  'programme.new.tier': 'Věková kategorie',
  'programme.new.name': 'Název',
  'programme.new.namePlaceholder': 'např. „Kür A" — potřebné jen k odlišení více sestav',
  'programme.new.create': 'Vytvořit',
  'programme.deleteProgramme': 'Smazat sestavu',
  'programme.deleteConfirm': 'Tato sestava je použita v {used} přihláškách, které se tím smažou také. Přesto smazat?',
  'programme.deleted': 'Sestava smazána.',
  'programme.duplicateProgramme': 'Duplikovat sestavu',
  'programme.duplicated': 'Sestava duplikována.',
  'programme.duplicateName': '{name} (kopie)',
  'programme.readout.aufgestellt': 'Nahlášeno celkem',
  'programme.readout.uebungen': 'Prvky',
  'programme.readout.profil': 'Profil obtížnosti',
  'programme.profileEmpty': 'zatím prázdné',
  'programme.duplicate': 'Zadáno dvakrát: <b>{list}</b>. Prvek se počítá jen jednou — opakování nepřináší žádné body.',
  'programme.bikes.two': 'Na dvou kolech',
  'programme.bikes.one': 'Na jednom kole',
  'programme.exercises.empty.title': 'Sestava je prázdná',
  'programme.exercises.empty.text': 'Vyber prvky z katalogu pro {label}.',
  'programme.addExercise': 'Přidat prvek',
  'programme.clear': 'Vyprázdnit sestavu',
  'programme.clearConfirm': 'Odebrat všechny prvky z této sestavy?',
  'programme.cleared': 'Sestava vyprázdněna.',
  'programme.share': 'Sdílet sestavu',
  'programme.catalogueLoading': 'Načítá se katalog figur…',
  'programme.figureNotFound': 'Prvek nenalezen',
  'programme.tactical.title': 'Taktické navýšení',
  'programme.tactical.upTo': 'T až {points}',
  'programme.final.title': 'UCI 8.2.011: povoleno pouze jako poslední prvek sestavy nebo bezprostředně před výměnou kola',
  'programme.final.tag': 'Závěrečný prvek',
  'programme.dragHandle': 'Přetažením změníte pořadí',
  'programme.moveUp': 'Posunout nahoru',
  'programme.moveDown': 'Posunout dolů',
  'programme.removeExercise': 'Odebrat prvek',

  'entries.title': 'Přihlášky',
  'entries.lede': 'Přihláška spojuje startujícího se závodem a odpovídající sestavou. Každá přihláška exportuje Kunstradmeldung/Teammeldung pro svůj závod.',
  'entries.empty.title': 'Zatím žádné přihlášky',
  'entries.empty.text': 'Přidej přihlášku a poté vyber její závod, startujícího a sestavu.',
  'entries.add': 'Přidat přihlášku',
  'entries.deleted': 'Přihláška smazána.',
  'entries.field.comp': 'Závod',
  'entries.field.starter': 'Startující',
  'entries.field.programm': 'Sestava',
  'entries.pickPlaceholder': '– vyber –',
  'entries.pickStarterFirst': 'nejprve vyber startujícího',
  'entries.incomplete': 'Neúplné',
  'entries.export': 'Export',
  'entries.unset': 'nevybráno',

  'share.imported': 'Sestava „{name}“ importována ze sdíleného odkazu.',
  'share.importedWithSkipped':
    'Sestava „{name}“ importována – {count} prvek/prvky nebyly nalezeny a byly přeskočeny.',
  'share.decodeError': 'Tento odkaz se nepodařilo přečíst – může být poškozený nebo pochází z novější verze aplikace.',

  'export.sheet.title': 'Export — {comp}',
  'export.check.title': 'Kontrola',
  'export.check.ok': 'Všechny povinné údaje obou schémat jsou úplné.',
  'export.loading': 'Načítá se katalog figur…',
  'export.issue.view': 'zobrazit',
  'export.kunstrad.title': 'Kunstradmeldung',
  'export.kunstrad.note': 'Startující, sportovci a sestava — kunstradmeldung.xsd, verze 19.0. {starters} startujících, {exercises} prvků.',
  'export.downloadXml': 'Stáhnout XML',
  'export.copyClipboard': 'Kopírovat do schránky',
  'export.team.title': 'Teammeldung',
  'export.team.note': 'Roční přihláška družstev — teammeldung.xsd, verze 1.1. {count} družstev{plural}.',
  'export.team.empty': 'Jakmile vznikne přihláška ve dvojici, čtyř- nebo šestičlenném družstvu, objeví se zde Teammeldung.',
  'export.workspace.title': 'Pracovní prostor',
  'export.workspace.note': 'Uloží údaje o klubech, osobách a sestavách do souboru, který lze později znovu otevřít.',
  'export.workspace.noStorage': ' Tento prohlížeč nic automaticky neukládá — ukládej pravidelně.',
  'export.workspace.save': 'Uložit pracovní prostor',
  'export.workspace.open': 'Otevřít pracovní prostor',
  'export.workspace.import': 'Importovat výběr…',
  'export.workspace.exportSelection': 'Exportovat výběr…',
  'export.workspace.reset': 'Vše obnovit',
  'export.resetConfirm': 'Smazat všechna data v tomto prohlížeči? Uložené soubory pracovního prostoru zůstanou zachovány.',
  'export.resetDone': 'Obnoveno.',

  'picker.title': 'Přidat prvek',
  'picker.searchPlaceholder': 'Hledat číslo, název nebo pojem …',
  'picker.searchLabel': 'Hledat prvek',
  'picker.groupLabel': 'Skupina prvků',
  'picker.allGroups': 'Všechny skupiny',
  'picker.minPlaceholder': 'od',
  'picker.maxPlaceholder': 'do',
  'picker.minLabel': 'Body od',
  'picker.maxLabel': 'Body do',
  'picker.reset': 'Obnovit',
  'picker.done': 'Hotovo',
  'picker.loading': 'Načítání katalogu prvků …',
  'picker.loadFailed': 'Katalog prvků se nepodařilo načíst.',
  'picker.tooMany': 'Více než {limit} prvků není povoleno.',
  'picker.added': '{id} přidán(a) · {points} b.',
  'picker.tacticalTitle': 'Možné taktické navýšení',
  'picker.finalTitle': 'UCI 8.2.011: povoleno pouze jako závěrečný prvek',
  'picker.noResults': 'Žádný prvek neodpovídá tomuto hledání. Zkus jiné pojmy nebo filtry.',
  'picker.limitReached': 'Dosaženo maxima {limit} prvků.',
  'picker.info': '{shown} výsledků · {have} z {limit} sestaveno · {points} b.',

  'rules.count.exceeded': 'Sestaveno {count} prvků, povoleno je nejvýše {max} (UCI {article}).',
  'rules.onBike.tooFew': '{count} prvků na jednom kole, vyžadováno je nejméně {min} (UCI {article}).',
  'rules.onBike.tooMany': '{count} prvků na jednom kole, povoleno je nejvýše {max} (UCI {article}).',
  'rules.onBike.needTwo': 'Sestava potřebuje i prvky na dvou kolech — oboje je povinné (UCI {article}).',
  'rules.final.single': 'Prvek {nr} (#{pos}) je závěrečný prvek a smí být pouze posledním prvkem sestavy (UCI 8.2.011).',
  'rules.final.pair': 'Prvek {nr} (#{pos}) je závěrečný prvek a smí být pouze posledním prvkem sestavy, nebo bezprostředně před výměnou kola (UCI 8.2.011).',
  'rules.raiser.continuity': 'Prvek {nr} (#{pos}) končí v postoji {label} — následující prvek musí pokračovat ve stejném typu zvednutí (UCI 8.2.028).',
  'rules.bikes.multipleSwitches': 'Prvek {nr} (#{pos}) znovu přechází mezi jedním a dvěma koly — sestava dvojic smí přejít z jednoho na druhé jen jednou (UCI 8.2.006).',
  'rules.figure.repeated': 'Prvek {nr} (#{pos}) opakuje prvek {first} (#{firstPos}) — každý prvek smí být v sestavě použit jen jednou (UCI 8.1.019).',

  'validate.meta.clubMissing': 'Údaje přihlášky: chybí přihlašující klub.',
  'validate.meta.clubTooLong': 'Údaje přihlášky: název klubu je příliš dlouhý',
  'validate.meta.federationTooLong': 'Údaje přihlášky: svaz je příliš dlouhý',
  'validate.contact.firstNameMissing': 'Odpovědná osoba: chybí jméno.',
  'validate.contact.lastNameMissing': 'Odpovědná osoba: chybí příjmení.',
  'validate.contact.emailMissing': 'Odpovědná osoba: chybí e-mail.',
  'validate.contact.emailTooLong': 'Odpovědná osoba: e-mail je příliš dlouhý',
  'validate.contact.uciIdTooLong': 'Odpovědná osoba: UCI ID je příliš dlouhé',
  'validate.comp.nameMissing': 'Závod: chybí název.',
  'validate.comp.dateMissing': 'Závod: chybí datum.',
  'validate.comp.venueMissing': 'Závod: chybí místo konání.',
  'validate.comp.dateInvalid': 'Závod: datum není platné.',
  'validate.comp.noneDefined': 'Zatím nebyl vytvořen žádný závod.',
  'validate.comp.noneSelected': 'Pro export není vybraný žádný závod.',
  'validate.noStarters': 'K tomuto závodu není přihlášen žádný startující.',
  'validate.entry.incomplete': '{count} přihláškám stále chybí startující nebo sestava — nebudou exportovány.',
  'validate.entry.duplicateStarter': '{who} je pro tento závod přihlášen {count}×  — každý startující smí být uveden jen jednou.',
  'validate.entry.typeMismatch': '{who} je typu {starterType}, ale vybraná sestava je pro {programType} — vyber odpovídající sestavu.',
  'validate.starter.riderCount': '{who}: přiřazeno {count} osob, {label} potřebuje {needed}.',
  'validate.starter.sexMismatch.one': '{who}: disciplína je ženská kategorie, ale {names} není evidován(a) jako žena.',
  'validate.starter.sexMismatch.many': '{who}: disciplína je ženská kategorie, ale {names} nejsou evidováni jako ženy.',
  'validate.starter.nameTooLong': '{who}: jméno startujícího je příliš dlouhé',
  'validate.starter.clubTooLong': '{who}: název klubu (odvozený z klubů osob) je příliš dlouhý',
  'validate.starter.disciplineTooLong': '{who}: disciplína je příliš dlouhá',
  'validate.starter.personalBestTooLong': '{who}: nejlepší výkon je příliš dlouhý',
  'validate.starter.scoringReportEmailTooLong': '{who}: e-mail pro hodnoticí zprávu je příliš dlouhý',
  'validate.starter.bestDateInvalid': '{who}: datum nejlepšího výkonu není platné.',
  'validate.programm.empty': '{who}: sestava je prázdná.',
  'validate.programm.tooMany': '{who}: sestaveno {count} prvků, povoleno je nejvýše {max}.',
  'validate.uebung.notFound': '{who}: prvek {nr} není v katalogu figur.',
  'validate.uebung.duplicate': '{who}: prvek {nr} je zadán vícekrát a počítá se jen jednou.',
  'validate.athlete.missing': '{who}: přiřazená osoba už neexistuje.',
  'validate.athlete.nameMissing': '{who}: {name} — chybí jméno nebo příjmení.',
  'validate.athlete.uciIdMissing': '{who}: {name} — chybí UCI ID.',
  'validate.athlete.uciIdTooLong': '{who}: {name} — UCI ID je příliš dlouhé',
  'validate.athlete.birthDateInvalid': '{who}: {name} — datum narození chybí nebo je neplatné.',
  'validate.athlete.nationInvalid': '{who}: {name} — národnost „{nation}" není ve schématu povolena.',
  'validate.singlesWarning': '{count} startujících jednotlivců se objeví jen v Kunstradmeldung — Teammeldung nezná disciplíny jednotlivců.',
  'validate.noTeams': 'Nebylo vytvořeno žádné družstvo — vznikne pouze Kunstradmeldung.',
  'validate.maxChars': ' (max. {n} znaků).',

  'lib.downloaded': 'Soubor {filename} stažen.',
  'lib.downloadFailedCopied': 'Stažení není možné — obsah zkopírován do schránky.',
  'lib.copiedClipboard': 'Zkopírováno do schránky.',
  'lib.copyFailed': 'Kopírování není možné — označ text v náhledovém poli.',

  'ie.title.import': 'Importovat výběr',
  'ie.title.export': 'Exportovat výběr',
  'ie.import.pick': 'Vybrat soubor k importu…',
  'ie.import.invalid': 'Tento soubor nelze načíst jako pracovní prostor.',
  'ie.import.noneSelected': 'Nic není vybráno.',
  'ie.import.done': 'Importováno {clubs} klubů, {athletes} sportovců, {comps} závodů, {starters} startujících, {programs} sestav, {entries} přihlášek ({skipped} už existovalo, přeskočeno).',
  'ie.export.done': 'Exportováno.',
  'ie.section.clubs': 'Kluby',
  'ie.section.comps': 'Závody',
  'ie.section.athletes': 'Sportovci',
  'ie.section.starters': 'Startující',
  'ie.section.programs': 'Sestavy',
  'ie.section.entries': 'Přihlášky',
  'ie.section.empty': 'žádné',
  'ie.item.starter': '{name} ({type})',
  'ie.item.program': '{name} ({count} prvků)',
  'ie.item.entry': '{starter} — {comp}',
  'ie.expand': 'Rozbalit',
  'ie.collapse': 'Sbalit',
  'ie.selectAll': 'Vybrat vše',
  'ie.selectNone': 'Zrušit výběr',
  'ie.confirm.import': 'Importovat',
  'ie.confirm.export': 'Exportovat',

  'webo.title': 'Import z WeBo2008',
  'webo.import.pick': 'Vybrat XML soubor z WeBo…',
  'webo.import.invalid': 'Tento soubor nelze načíst jako export z WeBo2008 (ani Kunstradmeldung, ani Teammeldung).',
  'webo.import.noneSelected': 'Nic není vybráno.',
  'webo.import.done':
    'Importováno {comps} závod, {starters} startujících ({athletesNew} nových sportovců, {athletesReused} už známých — z toho {athletesFilled} doplněno o chybějící údaje), {clubsNew} nových klubů, {programs} sestav, {entries} přihlášek.',
  'webo.category.registrationData': 'Hlavička přihlášky',
  'webo.category.registrationData.hint': 'Odpovědná osoba, klub a zemský svaz — přepíše aktuální údaje přihlášky',
  'webo.category.wettbewerb': 'Závod',
  'webo.category.wettbewerb.unavailable': 'Tento soubor neobsahuje žádné údaje o závodu (Teammeldung je nemá).',
  'webo.category.starter': 'Startující',
  'webo.category.programme': 'Sestavy',
  'webo.category.programme.unavailable': 'Tento soubor neobsahuje žádné údaje o sestavě (Teammeldung je nemá).',
  'webo.item.entry': '{name} — {discipline}',
  'webo.item.programme.ok': '{count} prvků, {points} b.',
  'webo.item.programme.mismatch': '{count} prvků ({unmatched} neznámých), body se liší ({rebuilt} místo {declared})',
  'webo.warnings.title': '{count} věc(í) ke kontrole:',
  'webo.warning.unknownNation': '{name}: národnost „{nation}" není rozpoznána.',
  'webo.warning.unknownRegionalFederation': 'Zemský svaz „{value}" není rozpoznán.',
  'webo.warning.unknownDiscipline': 'Disciplína „{discipline}" nerozpoznána — typ startu odhadnut z {count} osob(y).',
  // ------------------------------------------------------------------- pwa
  'pwa.offlineReady': 'Kür je nyní dostupný offline.',
  'pwa.updateAvailable': 'Je k dispozici nová verze.',
  'pwa.reload': 'Obnovit',
};

export default cs;
